import I18n from 'I18n';
import getIn from 'immutable-less/transmute/getIn';
import { ENROLLED_OBJECT, FETCHED_OBJECTS, ACTION_OUTPUTS, ENROLLMENT_DATASET, ENROLLMENT_EVENTS } from 'automation-ui-formula-editor/data-sources/constants/dataSourcesConstants';
export const extractDataSourceOptions = ({
  data,
  isEmbedded,
  isFirstAction,
  dataSourceAllowList = [ENROLLED_OBJECT, FETCHED_OBJECTS, ENROLLMENT_EVENTS, ENROLLMENT_DATASET, ACTION_OUTPUTS]
}) => {
  if (!data) {
    return [];
  }
  const fetchedObjectsOptions = isEmbedded ? [] : extractDataSourceChildrenOptions(data, FETCHED_OBJECTS);
  const crmDataSourceOptions = {
    text: I18n.text('automation-ui-formula-editor.data-passing-panel.panel-header.select-data-source.crm-properties'),
    options: [dataSourceAllowList.includes(ENROLLED_OBJECT) ? extractDataSourceOption(data, ENROLLED_OBJECT) : null, ...(dataSourceAllowList.includes(FETCHED_OBJECTS) && fetchedObjectsOptions || [])].filter(option => !!option)
  };
  if (isEmbedded) {
    return [crmDataSourceOptions];
  }
  const enrollmentDataSourceOptions = dataSourceAllowList.includes(ENROLLMENT_EVENTS) ? {
    text: I18n.text('automation-ui-formula-editor.data-passing-panel.panel-header.select-data-source.trigger-event-properties.label'),
    options: extractEnrollmentDataSourceOptions(data)
  } : null;
  const enrollmentDatasetSource = data.get(ENROLLMENT_DATASET) && dataSourceAllowList.includes(ENROLLMENT_DATASET) ? {
    text: I18n.text('automation-ui-formula-editor.data-passing-panel.panel-header.select-data-source.datasets.label'),
    options: [{
      text: I18n.text('automation-ui-formula-editor.data-passing-panel.panel-header.select-data-source.datasets.option'),
      value: ENROLLMENT_DATASET
    }]
  } : null;
  const actionDataSourceOptions = dataSourceAllowList.includes(ACTION_OUTPUTS) ? {
    text: I18n.text('automation-ui-formula-editor.data-passing-panel.panel-header.select-data-source.action-properties.label'),
    options: [isFirstAction ? {
      text: I18n.text('automation-ui-formula-editor.data-passing-panel.panel-header.select-data-source.action-properties.default-option'),
      value: ACTION_OUTPUTS,
      icon: null,
      disabled: true,
      help: I18n.text('automation-ui-formula-editor.data-passing-panel.panel-header.select-data-source.action-properties.no-data-sources.help')
    } : {
      text: I18n.text('automation-ui-formula-editor.data-passing-panel.panel-header.select-data-source.action-properties.default-option'),
      value: ACTION_OUTPUTS
    }]
  } : null;
  const dataSources = [crmDataSourceOptions];
  if (enrollmentDataSourceOptions) {
    dataSources.push(enrollmentDataSourceOptions);
  }
  if (actionDataSourceOptions) {
    dataSources.push(actionDataSourceOptions);
  }
  if (enrollmentDatasetSource) {
    dataSources.push(enrollmentDatasetSource);
  }
  return dataSources;
};
function extractEnrollmentDataSourceOptions(data) {
  const options = (extractDataSourceChildrenOptions(data, ENROLLMENT_EVENTS) || []).filter(option => !!option);
  if (options.length < 1) {
    return [{
      text: I18n.text('automation-ui-formula-editor.data-passing-panel.panel-header.select-data-source.trigger-event-properties.no-data-sources.label'),
      value: '',
      icon: null,
      disabled: true,
      help: I18n.text('automation-ui-formula-editor.data-passing-panel.panel-header.select-data-source.trigger-event-properties.no-data-sources.help')
    }];
  }
  return options;
}
function extractDataSourceOption(data, prefix) {
  const dataSource = getIn([prefix], data) || {};
  const dataSourceDefinition = getIn(['dataSourceDefinition'], dataSource);
  if (!dataSourceDefinition) {
    return null;
  }
  return {
    text: dataSourceDefinition.label,
    value: prefix
  };
}
function extractDataSourceChildrenOptions(data, prefix) {
  const dataSource = getIn([prefix], data);
  const dataSourceDefinition = getIn(['dataSourceDefinition'], dataSource);
  if (!dataSourceDefinition) {
    return null;
  }
  const childrenDataSources = getIn(['children'], dataSourceDefinition);
  return childrenDataSources.map(child => extractDataSourceOption(data, getIn(['toDataSource'], child)));
}